import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import {
    Col,
    Row,
    Label,
    Button,
    Form,
    Input,
    CardFooter,
    Card,
    CardBody,
    CardHeader,
} from "reactstrap";
import { useQuery } from "react-query";
import AsyncSelect from "react-select/async";
import ReportDetailsHeader from "Components/ReportDetailsHeader";
import { queryKeyes } from "shared/queryKeys";
import { getInputs } from "../EngineerReport.model";
import {
    Get,
} from "VesselMaster/vesselMaster.hooks";
import { useFormik } from "formik";
import {
    checkForNaN,
    checkValidArray,
    dateTimeFormat,
    handleServerResponse,
    isFormUnchanged,
    saveEditForm,
    searchCountries,
    searchPorts,
    useSafeFormikContext,
} from "GenericForms/Helper";
import Loading from "Components/Loading";
import ErrorComponent from "Components/ErrorComponent";
import apiGlobal from "global/api.global";
import FormValuesDebug from "utils/debugTools/FormValuesDebug";
import { queryClient } from "react-query/queryClient";
import { commonValidationMessages } from "Components/ValidationErrorMessages";
import env from "environment_system/env_system";
import { PortConstant } from "shared/constants";
import { customStyle } from "shared/CommonCSS";
import ErrorTooltip from "Components/ErrorTooltip";
import Select from "react-select";
import { useDocumentTitle } from "Components/useDocument.hooks";
import { RootState } from "index";
import { useSelector, useDispatch } from "react-redux";
import { getCurrentReportAction } from "Store/Generic/ReportingSlice";
import { getAuthData } from "utils/auth/authUtils";
import { useEditReport } from "VesselReportingInfo/EditCompletedReports/EditReportProvider";
interface LubeOilBunkeringType {
    toggleDynamicTabs?: any;
    setErrorMessage?: any;
}

const LubeOilBunkeringComponent = ({
    toggleDynamicTabs,
    setErrorMessage,
}: LubeOilBunkeringType) => {
    /** State variables */
    const { editReportBool, setPreviousTabIndex, previousEnggTabIndex, discardwarning } = useEditReport();
    let { LO_Bunkering_inputs } = getInputs("lo_bunkering");
    const { VesselID, ReportID, VoyageID, CurrentReport, PreviousReport, ConfigurationLimits, reportingError, reportingLoading } = useSelector((state: RootState) => state.Reporting);
    const dispatch = useDispatch();
    const lubeOilBunkeringCurrentReport = CurrentReport?.data?.chief_engineer?.lube_oil_bunkering ?? null;
    const currentVesselReport = CurrentReport?.data?.vessel_reporting_information ?? null;
    const previousVesselReport = PreviousReport?.data?.vessel_reporting_information ?? null;
    const [otherPort, setOtherPort] = useState(false);
    const [otherPortName, setOtherPortName] = useState("");
    const [otherCountry, setOtherCountry] = useState(null);
    const [addOtherPort, setAddOtherPort] = useState(false);
    const [otherPortId, setOtherPortId] = useState(null);
    useDocumentTitle("Lube Oil Bunkering Report - ecoSAIL");
    // const [refreshKey, setRefreshKey] = useState<number>(0);
    const formikContext = useSafeFormikContext<any>();
    const editValues = formikContext?.values;
    const setEditValues = formikContext?.setValues;
    const editInitialValues = formikContext?.initialValues;
    const editSubmit = formikContext?.submitForm;
    const editIsSubmitting = formikContext?.isSubmitting;
    const VesselLubeOils = ConfigurationLimits?.vessel_lube_oil_list || [];
    /** State variables end */


    /** Other Ports from master */
    const {
        data: OtherPortsObject,
        isLoading: OtherPortsLoading,
    }: { data: any; isLoading: any; isError: any } = useQuery(
        [queryKeyes.masters.OtherPortMaster.key, VesselID, ReportID],
        async () => {
            return await Get(queryKeyes.masters.OtherPortMaster.url());
        },
        { staleTime: Infinity }
    );
    /** Queries end */

    /** Assign initial values to formik object */
    const getintialValueLubeOilBunkering = () => {
        let arr: any[] = [];
        if (checkValidArray(editInitialValues?.chief_engineer?.lube_oil_bunkering)) {
            return editInitialValues?.chief_engineer?.lube_oil_bunkering;
        } else if (checkValidArray(lubeOilBunkeringCurrentReport)) {
            return lubeOilBunkeringCurrentReport;
        } else if (VesselLubeOils && arr.length <= VesselLubeOils.length) {
            VesselLubeOils?.map((lube: any) => {
                return arr.push({
                    bunkered: 0,
                    date_of_bunkering: null,
                    vessel_lube_oil: lube.id,
                    port_of_bunkering: null,
                    other_port: null as number,
                    other_port_name: null as string,
                    other_country: null as number,
                    other_country_name: null as string,
                    vessel: VesselID,
                    voyage_information: VoyageID,
                    vessel_reporting_information: ReportID,
                    lo_bunkering: 0,
                    port_country_name: null as string,
                });
            });
        }
        return arr;
    };

    /** Lube oil bunkering Formik object */
    const LubeOilBunkeringFormik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            lubeOil: getintialValueLubeOilBunkering(),
        },
        validationSchema: env?.form_validation ? Yup.object().shape({
            lubeOil: Yup.array(
                Yup.object({
                    bunkered: Yup.string()
                        .matches(/^\d{1,7}(\.\d{0,2})?$/, "Please enter upto 7 digits only").required(commonValidationMessages.required),
                    port_of_bunkering: Yup.number().required(
                        commonValidationMessages.required
                    ),
                    date_of_bunkering: Yup.date()
                        .min(dateTimeFormat(previousVesselReport?.local_time, true), `${commonValidationMessages.minDateLastRecord} (${dateTimeFormat(previousVesselReport?.local_time, false, false, true)})`)
                        .max(dateTimeFormat(currentVesselReport?.local_time, true), commonValidationMessages.maxDateCurrentRecord)
                        .when("bunkered", (val: any, schema) => {
                            return (val && val[0] > '0')
                                ? schema.required(commonValidationMessages.required)
                                : schema.nullable();
                        }),
                    other_port: Yup.string().when(
                        "$fieldAvailability",
                        (field: any, schema) => {
                            return !(
                                otherPort === true &&
                                OtherPortsObject
                            )
                                ? schema.nullable()
                                : schema.required(commonValidationMessages.required);
                        }
                    ),
                    other_port_name: Yup.string().when(
                        "$fieldAvailability",
                        (field: any, schema) => {
                            return !(addOtherPort === true || !OtherPortsObject)
                                ? schema.nullable()
                                : schema.required(commonValidationMessages.required)
                                    .min(2, "Must be at least 2 characters")
                                    .max(200, "Must be at most 200 characters");
                        }
                    ),
                    other_country: Yup.number().when(
                        "$fieldAvailability",
                        (field: any, schema) => {
                            return !(addOtherPort === true || !OtherPortsObject)
                                ? schema.nullable()
                                : schema.required(commonValidationMessages.required);
                        }
                    ),
                })
            ),
        }) : null,
        onSubmit: async (values: any, actions: any) => {
            if (env?.form_validation === false || isFormUnchanged(LubeOilBunkeringFormik.initialValues, values)) {
                toggleDynamicTabs(previousEnggTabIndex + 1);
                return;
            }
            actions.setSubmitting(true);
            await LOBunkeringSubmit(values, actions);
        }
    });

    /** useEffect start */
    useEffect(() => {
        const bunker = editInitialValues?.chief_engineer?.lube_oil_bunkering?.[0];
        if (editReportBool && bunker?.port_country_name === "Other-Other" && bunker?.other_port === null) {
            setAddOtherPort(true);
        }
    }, [editReportBool, editInitialValues?.chief_engineer?.lube_oil_bunkering]);

    useEffect(() => {
        if (editReportBool) {
            // use editValues
            if (checkValidArray(editValues?.chief_engineer?.lube_oil_bunkering)) {
                const bunkering = editValues?.chief_engineer?.lube_oil_bunkering?.[0];
                if (bunkering?.port_country_name === 'Other-Other' && addOtherPort === false) {
                    setOtherPort(true);
                    setOtherPortId(bunkering?.other_port);
                    setOtherPortName(bunkering?.other_port_name);
                    setOtherCountry(bunkering?.other_country);
                } else {
                    setOtherPort(false);
                }
            }
        } else {
            const bunkering = LubeOilBunkeringFormik?.values?.lubeOil?.[0];
            if (bunkering?.port_precedence_id === PortConstant.OTHER) {
                if (addOtherPort === false) {
                    setOtherPort(true);
                } else {
                    setOtherPort(false);
                }
                setOtherPortId(bunkering?.other_port);
                setOtherPortName(bunkering?.other_port_name);
                setOtherCountry(bunkering?.other_country);
            } else {
                setOtherPort(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editReportBool, editValues, lubeOilBunkeringCurrentReport, addOtherPort]);
    useEffect(() => {
        if (Array.isArray(editValues?.chief_engineer?.lube_oil_bunkering) &&
            !isFormUnchanged(LubeOilBunkeringFormik?.initialValues?.lubeOil, LubeOilBunkeringFormik?.values?.lubeOil)) {
            const updatedBunkering = LubeOilBunkeringFormik?.values?.lubeOil?.map((bunker: any) => {
                return ({
                    ...bunker,
                    id: bunker?.id > 0 ? bunker?.id : null,
                    report_index: bunker?.report_index > 0 ? bunker?.report_index : null,
                    created_by: bunker?.created_by > 0 ? bunker?.created_by : getAuthData('user_id'),
                    modified_by: bunker?.modified_by > 0 ? bunker?.modified_by : getAuthData('user_id'),
                })
            })
            setEditValues({
                ...editValues,
                chief_engineer: {
                    ...editValues?.chief_engineer,
                    lube_oil_bunkering: updatedBunkering
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [LubeOilBunkeringFormik?.values?.lubeOil]);
    /** useEffect end */

    const responseArray: any = [];
    /** Post submit actions based on response */
    const handleResponse = () => {
        dispatch(getCurrentReportAction(VesselID, ReportID));
        if (env?.form_validation === true) {
            setErrorMessage(null)
            toggleDynamicTabs(previousEnggTabIndex + 1);
        }
    };

    /** PUT request for LO Bunkering */
    const putLOBunkering = (value: any) => {
        responseArray.push(apiGlobal
            .put(`/lube_oil_bunkering/${value.id}/`, value))
    };

    /** POST request for LO Bunkering */
    const postLOBunkering = (values: any) => {
        responseArray.push(apiGlobal
            .post(`/lube_oil_bunkering/`, values))
    };

    /** Submit function for LO Bunkering */
    const LOBunkeringSubmit = async (values: any, actions: any) => {
        /** Select port of bunkering */
        values.lubeOil.map((lube: any) => {
            lube.other_port = otherPortId;
            lube.other_port_name = otherPortName;
            lube.other_country = otherCountry;
            return "";
        });
        /** Lube oil bunkering submit */
        if (checkValidArray(lubeOilBunkeringCurrentReport)) {
            values.lubeOil.forEach((lube: any) => {
                putLOBunkering(lube);
            });
        } else {
            postLOBunkering(values.lubeOil);
        }
        const response = await handleServerResponse(responseArray);
        if (response === true) {
            if (addOtherPort && OtherPortsObject &&
                OtherPortsObject?.filter((port: any) =>
                    port?.port_name === values?.lubeOil[0]?.other_port_name)?.length === 0) {
                await queryClient.invalidateQueries(queryKeyes.masters.OtherPortMaster.key);
            }
            handleResponse();
        } else {
            setErrorMessage(response)
        }
        actions.setSubmitting(false);
    };

    return (
        <Card className="p-0 mb-0 border-0">
            <CardHeader className="p-2">
                <Row>
                    <Col>
                        <h4 className="page_title mb-0">Lube Oil Bunkering </h4>
                        <p className="card-title-desc pos-start">
                            All readings since last report
                        </p>
                    </Col>
                    <Col>
                        <ReportDetailsHeader />
                    </Col>
                </Row>
            </CardHeader>
            {(
                reportingLoading ||
                OtherPortsLoading
            ) && <Loading message="Loading required data!" />}
            {reportingError && <ErrorComponent message="Unable to load required data!" />}
            {!(
                reportingLoading ||
                OtherPortsLoading
            ) &&
                !reportingError && (
                    <Form autoComplete="off" onSubmit={LubeOilBunkeringFormik?.handleSubmit} noValidate>
                        <CardBody className="px-2 py-0">
                            <Row>
                                {VesselLubeOils && (
                                    <>
                                        <Col lg={4} className="mb-2">
                                            <Label
                                                className="asteric mb-0"
                                                for="port_of_bunkering_0"
                                            >
                                                Port of bunkering
                                            </Label>
                                            <AsyncSelect
                                                name={`lubeOil.0.port_of_bunkering`}
                                                inputId="port_of_bunkering_0"
                                                cacheOptions
                                                autoFocus={true}
                                                defaultOptions
                                                loadOptions={(e: any) => searchPorts(e)}
                                                getOptionLabel={(e: any) => e?.port_country_name}
                                                getOptionValue={(e) => e.id}
                                                onBlur={() => LubeOilBunkeringFormik?.setFieldTouched(`lubeOil.0.port_of_bunkering`, true)}
                                                onChange={(e: any) => {
                                                    LubeOilBunkeringFormik?.values?.lubeOil?.forEach((bunker: any, index: number) => {
                                                        LubeOilBunkeringFormik?.setFieldValue(`lubeOil.${index}.port_of_bunkering`, e?.id);
                                                        LubeOilBunkeringFormik?.setFieldValue(`lubeOil.${index}.port_country_name`, e?.port_country_name);
                                                        LubeOilBunkeringFormik?.setFieldValue(`lubeOil.${index}.port_precedence_id`, e?.precedence_id);
                                                    });
                                                    if (
                                                        e?.precedence_id === PortConstant.OTHER &&
                                                        addOtherPort === false
                                                    ) {
                                                        setOtherPort(true);
                                                    } else if (
                                                        e?.precedence_id !== PortConstant.OTHER
                                                    ) {
                                                        setOtherPort(false);
                                                        setAddOtherPort(false);
                                                        setOtherPortId(null);
                                                        setOtherPortName(null);
                                                        setOtherCountry(null);
                                                        if (
                                                            LubeOilBunkeringFormik?.values?.lubeOil &&
                                                            LubeOilBunkeringFormik?.values?.lubeOil?.length > 0
                                                        ) {
                                                            LubeOilBunkeringFormik?.values?.lubeOil?.forEach(
                                                                (bunker: any, index: any) => {
                                                                    LubeOilBunkeringFormik?.setFieldValue(`lubeOil.${index}.other_port`, null);
                                                                    LubeOilBunkeringFormik?.setFieldValue(`lubeOil.${index}.other_port_name`, null);
                                                                    LubeOilBunkeringFormik?.setFieldValue(`lubeOil.${index}.other_country`, null);
                                                                    LubeOilBunkeringFormik?.setFieldValue(`lubeOil.${index}.other_country_name`, null);
                                                                    LubeOilBunkeringFormik?.setFieldValue(`lubeOil.${index}.port_country_name`, e.port_country_name);
                                                                }
                                                            );
                                                        }
                                                    }
                                                }}
                                                menuPortalTarget={document.body}
                                                defaultValue={{
                                                    id: LubeOilBunkeringFormik.values?.lubeOil?.[0]?.port_of_bunkering,
                                                    port_country_name: LubeOilBunkeringFormik.values?.lubeOil?.[0]?.port_country_name,
                                                }}
                                                noOptionsMessage={(e: any) => {
                                                    if (e?.inputValue?.toString()?.length > 2) {
                                                        return "Please select the Other option and enter the port name in the textbox provided";
                                                    }
                                                    return "Please enter the first 3 characters of port name";
                                                }}
                                            />
                                            {LubeOilBunkeringFormik?.errors.lubeOil && LubeOilBunkeringFormik?.touched.lubeOil &&
                                                LubeOilBunkeringFormik?.errors?.lubeOil[0]?.port_of_bunkering &&
                                                LubeOilBunkeringFormik?.touched?.lubeOil[0]?.port_of_bunkering &&
                                                env?.form_validation === true && !discardwarning && (
                                                    <ErrorTooltip
                                                        target={`port_of_bunkering_0`}
                                                        message={LubeOilBunkeringFormik?.errors?.lubeOil[0]?.port_of_bunkering}
                                                        open={!!LubeOilBunkeringFormik?.errors?.lubeOil[0]?.port_of_bunkering}
                                                    />
                                                )}
                                        </Col>
                                        {/* {JSON.stringify(otherPort)} */}
                                        {otherPort === true && addOtherPort === false &&
                                            OtherPortsObject && (
                                                <Col lg={4}>
                                                    <Label
                                                        className="mb-0 asteric"
                                                        for="other_port_name_dropdown"
                                                    >
                                                        Other port
                                                    </Label>
                                                    <Select
                                                        name="lubeOil.0.other_port"
                                                        inputId="other_port_name_dropdown"
                                                        options={OtherPortsObject}
                                                        getOptionLabel={(e: any) => e.port_name}
                                                        getOptionValue={(e: any) => e.id}
                                                        onBlur={() =>
                                                            LubeOilBunkeringFormik?.setFieldTouched("lubeOil.0.other_port", true)
                                                        }
                                                        onChange={(selectedOption: any) => {
                                                            LubeOilBunkeringFormik?.values?.lubeOil?.forEach(
                                                                (bunker: any, index: any) => {
                                                                    LubeOilBunkeringFormik?.setFieldValue(
                                                                        `lubeOil.${index}.other_port`,
                                                                        selectedOption.id
                                                                    );
                                                                    LubeOilBunkeringFormik?.setFieldValue(
                                                                        `lubeOil.${index}.other_port_name`,
                                                                        selectedOption?.port_name
                                                                    );
                                                                    LubeOilBunkeringFormik?.setFieldValue(
                                                                        `lubeOil.${index}.other_country`,
                                                                        selectedOption?.country
                                                                    );
                                                                }
                                                            );
                                                            setOtherPortId(selectedOption?.id);
                                                            setOtherPortName(
                                                                selectedOption?.port_name
                                                            );
                                                            setOtherCountry(selectedOption?.country);
                                                        }}
                                                        defaultValue={{
                                                            id: LubeOilBunkeringFormik.values?.lubeOil?.[0]?.other_port,
                                                            port_name: LubeOilBunkeringFormik.values?.lubeOil?.[0]?.other_port_name,
                                                        }}
                                                        menuPortalTarget={document.body}
                                                        styles={customStyle}
                                                        noOptionsMessage={(e: any) => {
                                                            if (
                                                                e?.inputValue?.toString()?.length > 2
                                                            ) {
                                                                return "Please select the Other option and enter the port name in the textbox provided";
                                                            }
                                                            return "Please enter the first 3 characters of port name";
                                                        }}
                                                    />
                                                    {LubeOilBunkeringFormik?.errors.lubeOil &&
                                                        LubeOilBunkeringFormik?.errors?.lubeOil[0]?.other_port &&
                                                        env?.form_validation === true && !discardwarning && (
                                                            <ErrorTooltip
                                                                target={`other_port_name_dropdown`}
                                                                message={LubeOilBunkeringFormik?.errors?.lubeOil[0]?.other_port}
                                                                open={
                                                                    LubeOilBunkeringFormik?.errors?.lubeOil[0]?.other_port ? true : false
                                                                }
                                                            />
                                                        )}
                                                    <p
                                                        className="link_color_blue pointer"
                                                        onClick={async () => {
                                                            setAddOtherPort(true);
                                                            setOtherPort(false);
                                                            LubeOilBunkeringFormik?.values?.lubeOil?.forEach((_bunker: any, index: number) => {
                                                                LubeOilBunkeringFormik.setFieldValue(`lubeOil.${index}.other_port`, null);
                                                                LubeOilBunkeringFormik.setFieldValue(`lubeOil.${index}.other_port_name`, null);
                                                                LubeOilBunkeringFormik.setFieldValue(`lubeOil.${index}.other_country`, null);
                                                                LubeOilBunkeringFormik?.setFieldValue(`lubeOil.${index}.other_country_name`, null);
                                                            });
                                                        }}
                                                    >
                                                        Click here to add new port
                                                    </p>
                                                </Col>
                                            )}
                                        {(addOtherPort === true || !OtherPortsObject) && (
                                            <>
                                                <Col lg={4}>
                                                    <Label className="mb-0 asteric">
                                                        Other port name
                                                    </Label>
                                                    <Input
                                                        onFocus={(e) => e.target.select()}
                                                        type="text"
                                                        name={`lubeOil.0.other_port_name`}
                                                        id="other_port_name"
                                                        className="form-control"
                                                        onBlur={(e: any) => {
                                                            setOtherPortName(e.target.value);
                                                            if (
                                                                LubeOilBunkeringFormik?.values?.lubeOil &&
                                                                LubeOilBunkeringFormik?.values?.lubeOil?.length > 0
                                                            ) {
                                                                LubeOilBunkeringFormik?.values?.lubeOil?.forEach(
                                                                    (bunker: any, index: any) => {
                                                                        LubeOilBunkeringFormik?.setFieldValue(
                                                                            `lubeOil.${index}.other_port_name`,
                                                                            e.target.value
                                                                        );
                                                                    }
                                                                );
                                                            }
                                                        }}
                                                        defaultValue={
                                                            LubeOilBunkeringFormik?.values?.lubeOil[0]?.other_port_name
                                                        }
                                                    />
                                                    {LubeOilBunkeringFormik?.errors?.lubeOil &&
                                                        LubeOilBunkeringFormik?.touched?.lubeOil &&
                                                        LubeOilBunkeringFormik?.touched?.lubeOil[0]?.other_port_name &&
                                                        LubeOilBunkeringFormik?.errors?.lubeOil[0]?.other_port_name &&
                                                        !discardwarning &&
                                                        env?.form_validation === true && (
                                                            <ErrorTooltip
                                                                target={`other_port_name`}
                                                                message={LubeOilBunkeringFormik?.errors?.lubeOil[0]?.other_port_name}
                                                                open={!!LubeOilBunkeringFormik?.errors?.lubeOil[0]?.other_port_name}
                                                            />
                                                        )}
                                                </Col>
                                                <Col lg={4}>
                                                    <Label className="mb-0 asteric">
                                                        Other country name
                                                    </Label>
                                                    <AsyncSelect
                                                        name={`lubeOil.0.other_country`}
                                                        id={"other_country"}
                                                        cacheOptions
                                                        defaultOptions
                                                        loadOptions={(e: any) => searchCountries(e)}
                                                        getOptionLabel={(e: any) => e.country_name}
                                                        getOptionValue={(e: any) => e.id}
                                                        onBlur={() => {
                                                            LubeOilBunkeringFormik?.setFieldTouched(`lubeOil.0.other_country`, true);
                                                        }}
                                                        onChange={(e: any) => {
                                                            setOtherCountry(e?.id);
                                                            LubeOilBunkeringFormik?.values?.lubeOil?.forEach(
                                                                (bunker: any, index: any) => {
                                                                    LubeOilBunkeringFormik?.setFieldValue(`lubeOil.${index}.other_country`, e?.id);
                                                                    LubeOilBunkeringFormik?.setFieldValue(`lubeOil.${index}.other_country_name`, e?.country_name);
                                                                }
                                                            );
                                                        }}
                                                        defaultValue={{
                                                            id: LubeOilBunkeringFormik?.values?.lubeOil?.[0]?.other_country,
                                                            country_name: LubeOilBunkeringFormik?.values?.lubeOil?.[0]?.other_country_name,
                                                        }}
                                                        className="select-height"
                                                        menuPortalTarget={document.body}
                                                        styles={customStyle}
                                                        noOptionsMessage={() => {
                                                            return "Please enter the first 3 characters of country name";
                                                        }}
                                                    />
                                                    {LubeOilBunkeringFormik?.errors?.lubeOil &&
                                                        LubeOilBunkeringFormik?.touched?.lubeOil &&
                                                        LubeOilBunkeringFormik?.touched?.lubeOil[0]?.other_country &&
                                                        LubeOilBunkeringFormik?.errors?.lubeOil[0]?.other_country &&
                                                        env?.form_validation === true && !discardwarning && (
                                                            <ErrorTooltip
                                                                target={`other_country`}
                                                                message={LubeOilBunkeringFormik?.errors?.lubeOil[0]?.other_country}
                                                                open={!!LubeOilBunkeringFormik?.errors?.lubeOil[0]?.other_country}
                                                            />
                                                        )}
                                                </Col>
                                            </>
                                        )}
                                        <div className="table-responsive ">
                                            <table className="table mb-2">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th className="align-middle px-0 py-2 sr-no-width">
                                                            #
                                                        </th>
                                                        {LO_Bunkering_inputs.filter(
                                                            (table: any) => table.table_columns === true
                                                        )
                                                            .sort(
                                                                (a: any, b: any) =>
                                                                    a.table_columns_sequence -
                                                                    b.table_columns_sequence
                                                            )
                                                            .map(({ ...props }, index: number) => {
                                                                return (
                                                                    <th
                                                                        key={index}
                                                                        className={`align-middle p-2 ${index === 1 || index === 2 ? 'asteric' : ''}`}
                                                                    >
                                                                        {props.label}
                                                                    </th>
                                                                );
                                                            })}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {VesselLubeOils &&
                                                        VesselLubeOils.map(
                                                            (lubeOil: any, index: number) => (
                                                                <tr key={lubeOil.id}>
                                                                    <td className="align-middle p-2 text-center">
                                                                        {index + 1}
                                                                    </td>
                                                                    <td className="align-middle p-2">
                                                                        {lubeOil.vessel_lube_oil_name}
                                                                    </td>
                                                                    <td className="align-middle p-2">
                                                                        <div className="input-group">
                                                                            <Input
                                                                                onFocus={(e) => e.target.select()}
                                                                                type="text"
                                                                                className="form-control text-right max-width-7"
                                                                                id={`bunkered_${index}_qty`}
                                                                                name={`lubeOil.${index}.bunkered`}
                                                                                value={LubeOilBunkeringFormik?.values?.lubeOil[index]?.bunkered ?? ""}
                                                                                onBlur={LubeOilBunkeringFormik?.handleBlur}
                                                                                onChange={(e: any) => {
                                                                                    LubeOilBunkeringFormik?.handleChange(e); // always update formik state
                                                                                    const val = e.target.value;

                                                                                    // If bunkered is 0, reset date
                                                                                    if (val === "0" || Number(val) === 0) {
                                                                                        LubeOilBunkeringFormik?.setFieldValue(
                                                                                            `lubeOil.${index}.date_of_bunkering`,
                                                                                            "" // better than null for <input type="date" />
                                                                                        );
                                                                                    }
                                                                                }}
                                                                            />
                                                                            <div className="input-group-text">
                                                                                ltr
                                                                            </div>
                                                                        </div>
                                                                        {LubeOilBunkeringFormik?.errors?.lubeOil &&
                                                                            LubeOilBunkeringFormik?.touched?.lubeOil &&
                                                                            LubeOilBunkeringFormik?.touched?.lubeOil[index]?.bunkered &&
                                                                            LubeOilBunkeringFormik?.errors?.lubeOil[index]?.bunkered &&
                                                                            env?.form_validation && !discardwarning && (
                                                                                <ErrorTooltip
                                                                                    target={`bunkered_${index}_qty`}
                                                                                    message={LubeOilBunkeringFormik?.errors?.lubeOil[index]?.bunkered}
                                                                                    open={LubeOilBunkeringFormik?.errors?.lubeOil[index]?.bunkered}
                                                                                />
                                                                            )}
                                                                    </td>
                                                                    <td className="align-middle p-2 ps-0">
                                                                        <div>
                                                                            <input
                                                                                type="date"
                                                                                id={`bunkering_${index}_date`}
                                                                                name={`lubeOil.${index}.date_of_bunkering`}
                                                                                min={dateTimeFormat(
                                                                                    previousVesselReport?.local_time,
                                                                                    true
                                                                                )}
                                                                                max={dateTimeFormat(
                                                                                    currentVesselReport?.local_time,
                                                                                    true
                                                                                )}
                                                                                onBlur={LubeOilBunkeringFormik?.handleBlur}
                                                                                onChange={(e: any) =>
                                                                                    LubeOilBunkeringFormik?.handleChange(e)
                                                                                }
                                                                                className={`datetimepicker text-uppercase form-control max-width-7
                                                                                    ${checkForNaN(LubeOilBunkeringFormik?.values?.lubeOil[index]?.bunkered) === 0 ? "cursor-not-allowed" : ""}`}
                                                                                value={
                                                                                    LubeOilBunkeringFormik?.values?.lubeOil[index]?.date_of_bunkering ?? ""
                                                                                }
                                                                                disabled={checkForNaN(LubeOilBunkeringFormik?.values?.lubeOil[index]?.bunkered) <= 0}
                                                                            />
                                                                        </div>
                                                                        {LubeOilBunkeringFormik?.errors?.lubeOil &&
                                                                            LubeOilBunkeringFormik?.touched?.lubeOil &&
                                                                            LubeOilBunkeringFormik?.touched?.lubeOil[index]?.date_of_bunkering &&
                                                                            LubeOilBunkeringFormik?.errors?.lubeOil[index]?.date_of_bunkering &&
                                                                            env?.form_validation && !discardwarning && (
                                                                                <ErrorTooltip
                                                                                    target={`bunkering_${index}_date`}
                                                                                    message={LubeOilBunkeringFormik?.errors?.lubeOil[index]?.date_of_bunkering}
                                                                                    open={!!LubeOilBunkeringFormik?.errors?.lubeOil[index]?.date_of_bunkering}
                                                                                />
                                                                            )}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                )}
                            </Row>
                        </CardBody>
                        <CardFooter className="p-2 py-3">
                            <Row className="d-flex align-items-center flex-row-reverse">
                                <Col lg={10}>
                                    <div className="d-flex flex-wrap gap-3 justify_right">
                                        {/* {editReportBool &&
                                            <Button
                                                type="reset"
                                                color="danger"
                                                className="btn_size_cstm"
                                                onClick={() => {
                                                    setEditValues({
                                                        ...editValues,
                                                        chief_engineer: {
                                                            ...editValues?.chief_engineer,
                                                            lube_oil_bunkering: editInitialValues?.chief_engineer?.lube_oil_bunkering,
                                                        }
                                                    })
                                                    setRefreshKey(refreshKey + 1);
                                                }}
                                            >
                                                Reset
                                            </Button>
                                        } */}
                                        <Button
                                            type={editReportBool ? "button" : "submit"}
                                            color="primary"
                                            className="btn_size_cstm"
                                            disabled={LubeOilBunkeringFormik?.isSubmitting || editIsSubmitting}
                                            onClick={async () => {
                                                const validationErrors = await LubeOilBunkeringFormik?.validateForm();
                                                Object.keys(LubeOilBunkeringFormik?.values || {}).forEach((key) => {
                                                    const val = LubeOilBunkeringFormik?.values[key];
                                                    if (Array.isArray(val)) {
                                                        val.forEach((item, index) => {
                                                            Object.keys(item).forEach((field) => {
                                                                LubeOilBunkeringFormik?.setFieldTouched(`${key}[${index}].${field}`, true, false);
                                                            });
                                                        });
                                                    } else if (typeof val === "object" && val !== null) {
                                                        Object.keys(val).forEach((field) => {
                                                            LubeOilBunkeringFormik?.setFieldTouched(`${key}.${field}`, true, false);
                                                        });
                                                    } else {
                                                        LubeOilBunkeringFormik?.setFieldTouched(key, true, false);
                                                    }
                                                });
                                                if (editReportBool && Object.keys(validationErrors).length === 0) {
                                                    await saveEditForm(editSubmit, toggleDynamicTabs, previousEnggTabIndex, setPreviousTabIndex);
                                                    //setRefreshKey((prev: number) => prev + 1);
                                                }
                                            }}
                                        >
                                            {(LubeOilBunkeringFormik?.isSubmitting || editIsSubmitting) && (
                                                <i className="ms-2 spinner-border spinner-border-sm text-light me-2" />
                                            )}
                                            Next <i className="bx bx-chevron-right ms-1" />
                                        </Button>
                                    </div>
                                </Col>
                                <Col lg={2}>
                                    <Button
                                        type="button"
                                        color="primary"
                                        className="btn_size_cstm"
                                        onClick={() => {
                                            setErrorMessage(null);
                                            LubeOilBunkeringFormik?.setErrors({});
                                            LubeOilBunkeringFormik?.resetForm();
                                            toggleDynamicTabs(previousEnggTabIndex - 1);
                                        }}
                                    >
                                        <i className="bx bx-chevron-left me-1" /> Previous
                                    </Button>
                                </Col>
                            </Row>
                        </CardFooter>
                        <FormValuesDebug values={[LubeOilBunkeringFormik?.values, LubeOilBunkeringFormik?.errors, LubeOilBunkeringFormik?.touched]} />
                    </Form>
                )
            }
        </Card >
    );
};

export default LubeOilBunkeringComponent;
